var Account, m;

m = require('mithril');

Account = require('./Account');

module.exports = {
  view: function(ctrl, args) {
    return m('header.header', [
      m('.header__banner', m('a.header__link[href=/]', {
        config: m.route
      }, 'Photo Gallery')), m('.header__account', m(Account, {
        account: args.account
      }))
    ]);
  }
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL2FwcC9zcmMvdWkvY29tcG9uZW50cy9IZWFkZXIuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL2FwcC9zcmMvdWkvY29tcG9uZW50cy9IZWFkZXIuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUE7O0FBQUEsQ0FBQSxHQUFJLE9BQUEsQ0FBUSxTQUFSOztBQUNKLE9BQUEsR0FBVSxPQUFBLENBQVEsV0FBUjs7QUFFVixNQUFNLENBQUMsT0FBUCxHQUFpQjtFQUNoQixJQUFBLEVBQU0sU0FBQyxJQUFELEVBQU8sSUFBUDtXQUNMLENBQUEsQ0FBRSxlQUFGLEVBQW1CO01BQ2xCLENBQUEsQ0FBRSxpQkFBRixFQUNDLENBQUEsQ0FBRSx3QkFBRixFQUE0QjtRQUFDLE1BQUEsRUFBUSxDQUFDLENBQUMsS0FBWDtPQUE1QixFQUErQyxlQUEvQyxDQURELENBRGtCLEVBR2xCLENBQUEsQ0FBRSxrQkFBRixFQUFzQixDQUFBLENBQUUsT0FBRixFQUFXO1FBQUMsT0FBQSxFQUFTLElBQUksQ0FBQyxPQUFmO09BQVgsQ0FBdEIsQ0FIa0I7S0FBbkI7RUFESyxDQURVIn0=
